<div class="content-block light-control-host" id="application-creator-content">
  <div *ngIf="loading; else connectBlock">
    <h1><i class="fa-solid fa-spinner fa-spin"></i> {{ loadingText }}</h1>
  </div>
  <ng-template #connectBlock>
    <div id="connect-page-header" class="header-container">
      <div>
        <h1>Let's get connected</h1>
        <p class="header-description" *ngIf="applicationType === 'aws'">
          <ng-container *ngIf="stackSetsEnabled; else cfnDescription">
            Follow the StackSets instructions below to deploy access across your AWS accounts.
          </ng-container>
          <ng-template #cfnDescription>
            To replicate your primary environment to your recovery region, {{ uiService.productName }} needs limited
            access to your AWS accounts. This is easily accomplished by installing these CloudFormation templates.
          </ng-template>
        </p>
        <p class="header-description" *ngIf="applicationType === 'azure'">
          To replicate your primary environment to your recovery region, {{ uiService.productName }} needs limited
          access to your Azure subscriptions. This is easily accomplished by installing these Azure Resource Manager
          templates.
        </p>
      </div>
      <div class="flex-center-row form-controls">
        <button type="button" class="arpio-secondary-button" (click)="backButtonClick()">BACK</button>
        <button
          type="button"
          class="arpio-button margin-left"
          [disabled]="!accessConfigured"
          (click)="continueButtonClick()"
        >
          CONTINUE
        </button>
      </div>
    </div>

    <ng-template [ngIf]="applicationType === 'aws'">
      <!-- CloudFormation templates - ONLY when StackSets NOT enabled -->
      <ng-container *ngIf="!stackSetsEnabled">
        <aws-account-access-view
          class="margin-top"
          [state]="sourceAccessService.state"
          [stackName]="sourceAccessService.stack"
          [accessType]="Scope.SOURCE"
          [templateUrl]="sourceAccessTemplate"
          [awsAccountId]="sourceAccountId"
          [region]="sourceRegion"
          [completedTestCount]="sourceAccessService.tests"
          [stickyReferenceId]="'connect-page-header'"
          (buttonClicked)="sourceAccessService.validateAccess()"
        >
        </aws-account-access-view>
        <aws-account-access-view
          class="margin-top"
          [state]="targetAccessService.state"
          [stackName]="targetAccessService.stack"
          [accessType]="Scope.TARGET"
          [templateUrl]="targetAccessTemplate"
          [awsAccountId]="targetAccountId"
          [region]="targetRegion"
          [completedTestCount]="targetAccessService.tests"
          [stickyReferenceId]="'connect-page-header'"
          (buttonClicked)="targetAccessService.validateAccess()"
        >
        </aws-account-access-view>
      </ng-container>

      <!-- StackSets instructions - ONLY when StackSets enabled -->
      <stacksets-instructions
        *ngIf="stackSetsEnabled"
        class="margin-top"
        [sourceStackSetTemplateUrl]="sourceStackSetTemplateUrl"
        [targetStackSetTemplateUrl]="targetStackSetTemplateUrl"
        [sourceTemplateBucket]="sourceTemplateBucket"
        [sourceTemplateKey]="sourceTemplateKey"
        [targetTemplateBucket]="targetTemplateBucket"
        [targetTemplateKey]="targetTemplateKey"
        [sourceAccountId]="sourceAccountId"
        [sourceRegion]="sourceRegion"
        [targetAccountId]="targetAccountId"
        [targetRegion]="targetRegion"
        [sourceStackName]="sourceAccessService?.stack"
        [targetStackName]="targetAccessService?.stack"
        [sourceManagedByStackSet]="sourceAccessService?.managedByStackSet"
        [targetManagedByStackSet]="targetAccessService?.managedByStackSet"
        [stickyReferenceId]="'connect-page-header'"
        [testingSource]="isTestingSourceAccess"
        [testingTarget]="isTestingTargetAccess"
        [sourceError]="sourceAccessService?.hasApiError"
        [targetError]="targetAccessService?.hasApiError"
        [sourceTestCount]="sourceAccessService?.tests"
        [targetTestCount]="targetAccessService?.tests"
        (testAccess)="onTestAccess($event)"
      ></stacksets-instructions>
    </ng-template>

    <ng-template [ngIf]="applicationType === 'azure'">
      <azure-access-view
        class="margin-top"
        [state]="targetAccessService.state"
        [accessType]="Scope.TARGET"
        [installCommand]="targetInstallCommand"
        [subscriptionId]="targetAccountId"
        [region]="targetRegion"
        [completedTestCount]="targetAccessService.tests"
        (buttonClicked)="targetAccessService.validateAccess()"
      >
      </azure-access-view>
      <div *ngIf="!targetAccessService.allGood" class="pending-notice margin-top">
        <i class="fa-solid fa-circle-info"></i>
        <span>Complete the recovery environment setup above before configuring the primary environment.</span>
      </div>
      <azure-access-view
        class="margin-top"
        [class.disabled-pending]="!targetAccessService.allGood"
        [state]="sourceAccessService.state"
        [accessType]="Scope.SOURCE"
        [installCommand]="sourceInstallCommand"
        [subscriptionId]="sourceAccountId"
        [region]="sourceRegion"
        [completedTestCount]="sourceAccessService.tests"
        (buttonClicked)="sourceAccessService.validateAccess()"
      >
      </azure-access-view>
    </ng-template>
  </ng-template>
</div>
